// extracted by mini-css-extract-plugin
module.exports = {"wrap":"qd","heading":"rd","items":"sd","featureCss":"td","disabled":"ud","imgCss":"vd"};